export enum BydAdminUserServiceEnum {
  GET_USER_ENDPOINT = '/users/',
}
